export class LocationGraphData {
    constructor(
        public country: string,
		public city: string,
		public value: number
    ){}
}



// WEBPACK FOOTER //
// ./src/app/models/location-graph-data.ts